// extracted by mini-css-extract-plugin
module.exports = {"module-list":"_5D3--hRw","container":"_5D3U5w3W","card":"_5D1YzAlc","loader":"_5D37bKoe"};